export { getCurrentUrl };
import { parseUrl } from './parseUrl';
import { assert } from './assert';
function getCurrentUrl(options) {
    const url = window.location.href;
    const { origin, searchOriginal, hashOriginal, pathnameOriginal } = parseUrl(url, '/');
    let urlCurrent;
    if (options === null || options === void 0 ? void 0 : options.withoutHash) {
        urlCurrent = `${pathnameOriginal}${searchOriginal || ''}`;
        const urlRecreated = `${origin || ''}${urlCurrent}${hashOriginal || ''}`;
        assert(url === urlRecreated, { url, urlRecreated });
    }
    else {
        urlCurrent = `${pathnameOriginal}${searchOriginal || ''}${hashOriginal || ''}`;
        const urlRecreated = `${origin || ''}${urlCurrent}`;
        assert(url === urlRecreated, { url, urlRecreated });
    }
    return urlCurrent;
}
